import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditNotificationType extends TermCreateEdit {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return "notification_type";
    }
}
